import { atom } from 'recoil';
import { OrganisationFormData, PaginatedResponse } from '../../../interfaces/Management.interface.ts';
import { RecoilAtomKey } from '../../recoilConstantKey.js';

export const organisationResponseAtom = atom<PaginatedResponse>({
    key: RecoilAtomKey.organisationResponseKey,
    default: {
        list: [],
        pages: 0,
        count: 0,
    },
});

export const organisationFilterAtom = atom({
    key: RecoilAtomKey.organisationFilterKey,
    default: {
        page: 0,
        search: '',
    },
});

export const organisationFormDataAtom = atom<OrganisationFormData>({
    key: RecoilAtomKey.organisationFormDataKey,
    default: { name: "", phone: "", email: "", category: "", comments: "", business_type: [], business_subtype: [], reference_name: "", reference_phone: "" ,selectedBusinessTypes:null,selectedBusinessSubTypes:null},
});
export const organisationFormDataErrorAtom = atom<any>({
    key: RecoilAtomKey.organisationFormDataErrorKey,
    default: {},
});

export const organisationTableStateAtom = atom({
    key: RecoilAtomKey.organisationTableStateKey,
    default: {
      cache: {},
      totalCountCache: {},
      filters: {
        limit: 20,
        search: '',
        page: 0,
        category:"",
      },
      isLoading: false,
    },
  });


